<template>
  <div>
    <div class="loading loading-label" v-if="showScreenLoader">&#8230;</div>
    <p class="text-center loading-text" v-if="showScreenLoader">{{screenLoaderText}}</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      showScreenLoader: (state) => state.showScreenLoader,
      screenLoaderText: (state) => state.screenLoaderText,
    }),
  },
};
</script>

<style scoped>
.loading-text{
	position: fixed;
    top: 55%;
    width: 100%;
    z-index: 1000;
    color: #000;
    font-weight: bold;
    font-size: 1.5rem;
}
   
</style>